const creditPack = {
  name: {
    label: "Nom",
    invalid: {}
  },
  quantity: {
    label: "Quantité",
    invalid: {}
  },
  quantityFree: {
    label: "Quantité offerte",
    invalid: {}
  },
  price: {
    label: "Prix",
    invalid: {}
  },
  available: {
    label: "Disponible",
    invalid: {}
  },
  lastPriceModifiedAt: {
    label: "Date de dernière modification",
    invalid: {}
  },
};

export default creditPack;
